<template>
  <div
    :style="sideNavigationStyle"
    class="sticky hidden w-[209px] shrink-0 overflow-y-auto pl-1 pt-1 lg:block"
  >
    <SideNavigation
      :categories="sidebarCategories"
      :feching="fetchingCategories"
    />
  </div>
</template>

<script setup>
import useNewPlp from '#layers/base/composables/plp/useNewPlp'
import useUiState from '~/composables/ui/useUiState'

const { sideNavigationStyle } = useUiState()
const { sidebarCategories, fetchingCategories } = useNewPlp()
</script>
